import * as selectors from "./selectors";
import menuSlice from "./slice";

export const MenuActions = { ...menuSlice.actions };
export const MenuReducer = menuSlice.reducer;
export const MenuSelectors = selectors;
